module.exports = __webpack_public_path__ + "static/img/manual_zh_35.f3aead4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_35.png
// module id = JxHo
// module chunks = 4